module.exports = __webpack_public_path__ + "media/applicants/referral-cdc8f9d0.png";